import React, { Component } from 'react'
import random from 'lodash.random'
import pull from 'lodash.pull'
import classNames from 'classnames'

import './ToggleGroup.scss'

export class ToggleGroup extends Component {
  constructor (props) {
    super(props)
    this.state = {
      selected: null,
      uniqueId: random(100000, 999999)
    }

    this.handleInputUpdate = this.handleInputUpdate.bind(this)
  }

  componentDidMount () {
    const { multiSelect, selected } = this.props
    this.setState({ selected })
    if (multiSelect) {
      if (Array.isArray(selected)) {
        if (selected.length > 0) {
          this.setState({ selected })
        } else {
          this.setState({ selected: [] })
        }
      } else {
        this.setState({ selected: [] })
        if (selected) console.error("'selected' props must be an array when multiSelect is enabled.")
      }
    }
  }

  componentWillUpdate (nextProps, nextState) {
    if (nextState.selected !== this.state.selected) this.props.onChange(nextState.selected)

  }

  handleInputUpdate (data, checked) {
    const { multiSelect } = this.props
    const { selected } = this.state
    if (multiSelect) {
      if (checked) this.setState({ selected: [...selected, data] })
      else this.setState({ selected: [...pull(selected, data)] })
    } else {
      this.setState({ selected: data })
    }
  }

  render () {
    let { branded, multiSelect, children, selected, onClick } = this.props
    const { uniqueId } = this.state
    let childrenWithProps
    if (multiSelect) {
      childrenWithProps = React.Children.map(children, child =>
        React.cloneElement(child, {
          type: multiSelect ? 'checkbox' : 'radio',
          onChange: this.handleInputUpdate,
          onClick: onClick,
          name: `radio_${uniqueId}`,
          checked: selected.includes(child.props.value)
        }))
    } else {
      childrenWithProps = React.Children.map(children, child =>
        React.cloneElement(child, {
          type: multiSelect ? 'checkbox' : 'radio',
          onChange: this.handleInputUpdate,
          onClick: onClick,
          name: `radio_${uniqueId}`,
          checked: child.props.value === selected
        }))
    }

    return (
      <div className={classNames(
        'af-toggle-group',
        { '--branded': branded }
      )}>
        {childrenWithProps}
      </div>
    )
  }
}

export const Tab = (props) => {
  const { type, value, name, checked, onChange, onClick, showBadge } = props
  const uniqueId = `radio_${name}_${value}`
  return (
    <div className='af-tab'>
      {showBadge && <span className='badge'></span>}
      <input id={uniqueId}
        type={type}
        value={value}
        name={name}
        checked={checked}
        onClick={onClick && ((ev) => onClick(ev.target.value, ev.target.checked))}
        onChange={(ev) => onChange(ev.target.value, ev.target.checked)} />
      <label htmlFor={uniqueId}>{props.children}</label>
    </div>
  )
}
